"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vetsSelector = exports.titlesSelector = exports.suburbsSelector = exports.mediasSelector = exports.gendersSelector = exports.felineBreedsSelector = exports.canineBreedsSelector = void 0;
var felineBreedsSelector = exports.felineBreedsSelector = function felineBreedsSelector(state) {
  return state.form.felineBreeds;
};
var canineBreedsSelector = exports.canineBreedsSelector = function canineBreedsSelector(state) {
  return state.form.canineBreeds;
};
var mediasSelector = exports.mediasSelector = function mediasSelector(state) {
  return state.form.medias;
};
var gendersSelector = exports.gendersSelector = function gendersSelector(state) {
  return state.form.genders;
};
var vetsSelector = exports.vetsSelector = function vetsSelector(state) {
  return state.form.vets;
};
var titlesSelector = exports.titlesSelector = function titlesSelector(state) {
  return state.form.titles;
};
var suburbsSelector = exports.suburbsSelector = function suburbsSelector(state) {
  return state.form.suburbs;
};